const timeToTimeAgo = (timestamp: number | undefined): string => {
	if (timestamp) {
		let nowDate = new Date()
		let nowTimestamp = Math.floor(nowDate.getTime() / 1000)
		let seconds = nowTimestamp - timestamp

		if (seconds > 31 * 2 * 24 * 3600) {
			return 'months ago'
		} else if (seconds > 31 * 24 * 3600) {
			return '2 months ago'
		} else if (seconds > 24 * 3600) {
			return `${Math.floor(seconds / (24 * 3600))} days ago`
		} else if (seconds > 3600) {
			return `${Math.floor(seconds / 3600)} hours ago`
		} else if (seconds > 60) {
			return `${Math.floor(seconds / 60)} minutes ago`
		} else return 'just now'
	} else {
		return 'time not found'
	}
}

const getRandomValue = (takeAway: string): string => {
	let topNum: number = Math.floor(Math.random() * 100)
	let topStr = `${topNum}%`
	if (topNum > 50) {
		topStr = `calc(${topNum}% - ${takeAway}rem)`
	}
	return topStr
}

export { timeToTimeAgo, getRandomValue }
